import * as React from 'react';
import { useNavigate } from 'react-router-dom';
import CssBaseline from '@mui/material/CssBaseline';
import Link from '@mui/material/Link';
import { Link as RouterLink } from 'react-router-dom';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import RadioButton from './../common/RadioButton';
import AuthContext from '../Context/AuthProvider';
import image from '../../assets/images/signuppage.jpg';

//Alerts
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import {
	sendOtpPhone,
	sendOtpEmail,
	validateOtpEmail,
	validateOtpPhone,
	phoneSignUp,
	emailSignUp,
	getMyProfile,
} from '../../services/auth';

import { countryCodes } from "../constants/Constants";
import { Collapse } from '@mui/material';
import { ExpandLess, ExpandMore } from '@mui/icons-material';
import InactivityHelpModal from '../common/InactivityHelpModal';

function Copyright(props) {
  return (
    <Typography
      variant="body2"
      color="text.secondary"
      align="center"
      {...props}
    >
      {"Copyright © "}
      <Link color="inherit" href="http://gsbsoirikapai.com/">
        GSB Soirika
      </Link>{" "}
      {new Date().getFullYear()}
      {"."}
    </Typography>
  );
}

export default function SignUpSide() {
  const { setAuth, setProfile, setUserRole } = React.useContext(AuthContext);
  let navigate = useNavigate();
  const [userExists, setUserExists] = React.useState(false);

  const [otpValidationToken, setOtpValidationToken] = React.useState("");
  const [email, setEmail] = React.useState("");
  const [emailError, setEmailError] = React.useState(false);

  const [phone, setPhone] = React.useState("");
  const [phoneError, setPhoneError] = React.useState("");

  const [password, setPassword] = React.useState("");
  const [passwordError, setPasswordError] = React.useState(false);

  const [passwordConfirm, setPasswordConfirm] = React.useState("");
  const [passwordConfirmError, setPasswordConfirmError] = React.useState(false);

  const [choice, setChoice] = React.useState("Phone");
  const [countryCode, setCountryCode] = React.useState("+91");

  const [showOTP, setShowOTP] = React.useState(false);
  const [showPassword, setShowPassword] = React.useState(false);

  const [otp, setOtp] = React.useState("");
  const [otpError, setOtpError] = React.useState("");
  const [search, setSearch] = React.useState("");
  const [isDropdownOpen, setIsDropdownOpen] = React.useState(false);
  const [showDisclaimer, setShowDisclaimer] = React.useState(false);
  const toggleDisclaimer = () => {
    setShowDisclaimer(!showDisclaimer);
  };
  const [resetTrigger, setResetTrigger] = React.useState(0); 
  const updateResetTrigger = () => setResetTrigger(prev => prev +1);
  const dropdownRef = React.useRef(null);

  // resend otp code

  const [minutes, setMinutes] = React.useState(0);
  const [seconds, setSeconds] = React.useState(0);
  const [resentOtp, setResentOTP] = React.useState("");

  React.useEffect(() => {
    const interval = setInterval(() => {
      if (seconds > 0) {
        setSeconds(seconds - 1);
      }

      if (seconds === 0) {
        if (minutes === 0) {
          clearInterval(interval);
        } else {
          setSeconds(59);
          setMinutes(minutes - 1);
        }
      }
    }, 1000);

    return () => {
      clearInterval(interval);
    };
  }, [seconds]);

  const emailValidation = () => {
    //regex email validation
    const emailRegex = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
    if (emailRegex.test(email)) {
      setEmailError(false);

      return true;
    } else {
      setEmailError(true);
      return false;
    }
  };
  const passwordValidation = () => {
    if (password.length < 1) {
      setPasswordError(true);

      return false;
    } else {
      setPasswordError(false);
      return true;
    }
  };
  const phoneValidation = () => {
    if (countryCode === "+91") {
      // India: 10 digits, not starting with 0
      const phoneRegex = /^[1-9][0-9]{9}$/;
      if (phoneRegex.test(phone)) {
        setPhoneError("");
        return true;
      } else {
        setPhoneError("Enter a valid 10-digit Indian phone number (without country code)");
        return false;
      }
    } else {
      // Other countries: 6-15 digits, not starting with 0
      const phoneRegex = /^[1-9][0-9]{5,14}$/;
      if (phoneRegex.test(phone)) {
        setPhoneError("");
        return true;
      } else {
        setPhoneError("Enter a valid phone number (6-15 digits, without country code)");
        return false;
      }
    }
  };
  const otpValidation = () => {
    //6 digit otp validation
    const otpRegex = /^[0-9]{6}$/;
    if (otpRegex.test(otp)) {
      setOtpError("");

      return true;
    } else {
      setOtpError("Please check the OTP again.");

      return false;
    }
  };

  const passwordConfirmValidation = () => {
    if (password === passwordConfirm) {
      setPasswordConfirmError(false);

      return true;
    } else {
      setPasswordConfirmError(true);

      return false;
    }
  };

  const handleChange = (event) => {
    updateResetTrigger()
    const { name, value } = event.target;
    switch (name) {
      case "email":
        setEmail(value);
        break;
      case "phone":
        setPhone(value);
        break;
      case "password":
        setPassword(value);
        break;
      case "passwordConfirm":
        setPasswordConfirm(value);
        break;
      case "choice":
        setChoice(value);
        setShowOTP(false);
        setShowPassword(false);
        break;
      case "otp":
        setOtp(value);
        break;
      default:
        break;
    }
  };

  const resubmitOTP = async () => {
    updateResetTrigger()
    try {
      if (choice === "Phone") {
        await sendOtpPhone(`${countryCode}${phone}`);
        setResentOTP("OTP has been resent to your phone");
      } else if (choice === "Email") {
        await sendOtpEmail(email);
        setResentOTP("OTP has been resent to your email");
      }
    } catch (error) {
      console.error("there has been an error", {
        phone,
        email,
        showOTP,
        showPassword,
        choice,
        error,
      });
      toast.error(
        "There has been an error in sending the otp, please contact admin",
        {
          timeOut: 1000,
        }
      );
    }
    setResentOTP("OTP resend failed");
  };

  const filteredCountryCodes = countryCodes.filter(
    (code) =>
      code.country.toLowerCase().includes(search.toLowerCase()) ||
      code.code.includes(search)
  );

  const handleSubmit = async () => {
    updateResetTrigger()
    setUserExists(false);
    try {
      if (choice === "Phone" && !showOTP && !showPassword) {
        if (phoneValidation()) {
          let response = await sendOtpPhone(`${countryCode}${phone}`);
          if (response.data.validatePhone) {
            setShowOTP(true);
            setMinutes(0);
            setSeconds(59);
          } else {
            if (
              response.errors &&
              response.errors[0]?.message?.includes("already exists")
            ) {
              toast.error(
                "There already exists a user with these credentials",
                {
                  timeOut: 1000,
                }
              );
              // Set userExists state so that banner is shown
              setUserExists(true);     
            } else {
              toast.error(
                "There was an unexpected error, please try again after some time",
                {
                  timeOut: 1000,
                }
              );
            }
          }
        }
      } else if (choice === "Email" && !showOTP && !showPassword) {
        if (emailValidation()) {
          await sendOtpEmail(email);
          setShowOTP(true);
          setMinutes(0);
          setSeconds(59);
        }
      } else if (choice === "start") {
        toast.info("Please choose your sign up method", {
          timeOut: 1000,
        });
      }
      if (showOTP && otpValidation()) {
        let otpValidationdata = null;
        if (choice === "Phone") {
          otpValidationdata = await validateOtpPhone(
            `${countryCode}${phone}`,
            otp
          );
        } else {
          otpValidationdata = await validateOtpEmail(email, otp);
        }
        if (
          otpValidationdata.data.validatePhoneOtp ||
          otpValidationdata.data.validateEmailOtp
        ) {
          let token =
            otpValidationdata.data.validatePhoneOtp ||
            otpValidationdata.data.validateEmailOtp;
          setOtpValidationToken(token);
          setShowPassword(true);
          setShowOTP(false);
        } else {
          // needs better handling as error can be something else
          toast.info("OTP validation failed, please check the OTP", {
            timeOut: 500,
          });
        }
      }
      if (showPassword && passwordValidation() && passwordConfirmValidation()) {
        let signUpdata = null;
        if (choice === "Phone") {
          signUpdata = await phoneSignUp(
            `${countryCode}${phone}`,
            password,
            otpValidationToken
          );
        } else {
          signUpdata = await emailSignUp(email, password, otpValidationToken);
        }
        console.log("errors in sigfn up data", signUpdata.data.errors);
        //TODO: try email sign up flow and validate e2e
        if (
          (choice === "Phone" && signUpdata.data.phoneSignup) ||
          signUpdata.data.emailSignup
        ) {
          toast.success("Sign up successful", {
            timeOut: 1000,
          });
          let token =
            choice === "Phone"
              ? signUpdata.data.phoneSignup
              : signUpdata.data.emailSignup;
          setAuth({
            token,
            authenticationByEmail: choice !== "Phone",
            authenticationUsername: choice === "Phone" ? phone : email,
          });
          let getProfile = await getMyProfile(token);
          if (getProfile.errors) {
            console.error("failure in getting my profile", getProfile.errors);
          } else {
            setProfile(getProfile.data.getMe.profile);
            let roles = getProfile.data.getMe.roles;
            if (roles.length > 0 && roles[0] === "admin") setUserRole("admin");
          }

          //Redirect to login page after 3 seconds using react router dom
          // setTimeout(() => {
          navigate("/");
          // }, 2000);
        } else {
          //need better handling
          console.error("sign up failed", signUpdata);
        }
      }
    } catch (error) {
      console.error("there has been an error", {
        phone,
        email,
        showOTP,
        showPassword,
        choice,
        error,
      });
    }
  };

  return (
    <div
      className="flex items-center justify-center h-screen bg-cover p-4"
      style={{
        backgroundImage: `url(${image})`,
      }}
    >
        <div className="flex flex-col justify-center w-full max-w-md bg-white p-8 max-h-[90vh] rounded-md shadow-2xl" style={{overflowY: 'auto'}}>
        
        <CssBaseline />
        <ToastContainer />
        <InactivityHelpModal resetTrigger={resetTrigger}/>

        <div className="flex flex-col items-center mb-2">
          <h1 className="text-2xl font-bold">SIGN UP</h1>
        </div>
        <div className="">
          <div onClick={() => {
              toggleDisclaimer();
              updateResetTrigger();
            }} 
            style={{ cursor: "pointer", fontWeight: "bold", display: "flex", justifyContent: "space-between", alignItems: "center", color: "#DC2626" }}
          >
          <span>Disclaimer</span>
          {showDisclaimer ? <ExpandLess /> : <ExpandMore />}
          </div>
          <Collapse in={showDisclaimer} timeout="auto" unmountOnExit>
            <p className="text-xs mt-2 text-red-600">
              If it is determined that the candidate is <strong>not a member</strong> of the GSB community, the account will be deactivated, and any payments made will be <strong>non-refundable</strong>.
            </p>
          </Collapse>
        </div>
        {userExists && (
          <div className="mb-4 p-3 bg-blue-50 border border-blue-300 text-blue-800 text-sm rounded-md text-center">
            An account with these credentials already exists.&nbsp;
            Please&nbsp;
            <RouterLink to="/login" className="font-bold underline text-blue-800">
              Sign In
            </RouterLink>
            &nbsp;or&nbsp;
            <RouterLink to="/forgot-password" className="font-bold underline text-blue-800">
              Reset Password
            </RouterLink>.
          </div>
        )}
        <Box component="form" noValidate s={{ mt: 4 }} onSubmit={(e) => { e.preventDefault(); handleSubmit(); }}>
          {!showPassword && (
            <RadioButton
              disabled={showOTP}
              label="Choose your Sign Up method"
              name="choice"
              value={choice}
              onChange={handleChange}
              className="mb-2"
              options={[
                {
                  value: "Phone",
                  label: "Phone",
                },
                {
                  value: "Email",
                  label: "Email",
                },
              ]}
            />
          )}
          {/* PHONE NUMBER */}
          {choice === "Phone" && !showPassword && (
            <div>
              <label
                htmlFor="countryCode"
                className="block text-sm font-medium text-gray-500"
              >
                Country Code
              </label>
              <div className="relative" ref={dropdownRef}>
                <button
                  type="button"
                  onClick={() => {
                    updateResetTrigger();
                    setIsDropdownOpen(!isDropdownOpen)
                  }}
                  className="select select-bordered w-full bg-white"
                  disabled={showOTP}
                >
                  <p className="my-auto">
                    {countryCode} (
                    {
                      countryCodes.find((code) => code.code === countryCode)
                        .country
                    }
                    )
                  </p>
                </button>

                {!showOTP && isDropdownOpen && (
                  <div className="absolute z-10 mt-1 w-full bg-white shadow-lg max-h-60 rounded-md overflow-auto">
                    <input
                      type="text"
                      className="input input-bordered w-full px-2 py-1 bg-white text-black"
                      placeholder="Search country or code"
                      value={search}
                      onChange={(e) => {
                        updateResetTrigger();
                        setSearch(e.target.value)
                      }}
                    />
                    <ul className="py-1">
                      {filteredCountryCodes.map((code) => (
                        <li
                          key={code.code}
                          className="cursor-pointer hover:bg-gray-100 px-2 py-1"
                          onClick={() => {
                            updateResetTrigger();
                            setCountryCode(code.code);
                            setIsDropdownOpen(false);
                          }}
                        >
                          {code.code} ({code.country})
                        </li>
                      ))}
                    </ul>
                  </div>
                )}
              </div>
            </div>
          )}
          {choice === "Phone" && !showPassword && (
            <input
            className={`input input-primary bg-white border border-gray-100 focus:outline-none focus:border-1 w-full my-2 ${
              showOTP ? 'text-gray-400' : 'text-black'
            }`}  
              variant="standard"
              margin="normal"
              disabled={showOTP}
              required
              fullWidth
              id="phone"
              label="Phone Number"
              placeholder="Enter your phone number"
              name="phone"
              autoComplete="phone"
              error={phoneError}
              onChange={handleChange}
              helperText={phoneError ? "Phone number is invalid" : ""}
            />
          )}
           {phoneError && (
              <p className="text-red-500 text-xs mt-1">{phoneError}</p>
            )}
          {/* EMAIL */}
          {choice === "Email" && !showPassword && (
            <>
              {/* <TextField
										variant='standard'
										margin='normal'
										disabled={showOTP}
										required
										fullWidth
										id='email'
										label='Email Address'
										name='email'
										autoComplete='email'
										placeholder='Enter your email'
										error={emailError}
										onChange={handleChange}
										helperText={
											emailError ? 'Email is invalid' : ''
										}
									/> */}
                  <div>
										Email onboarding is not supported yet, we are working on it! Please contact support team 
                    <a
                      href="tel:+918296919479"
                      style={{ color: "#1976d2", textDecoration: "none", fontWeight: "bold" }}
                    >
                      +91 82969 19479
                    </a>{' '} 
                    if you need email based onboarding.
									</div>
            </>
          )}
          {/* OTP */}
          {showOTP && (
            <>
              <input
                className={`input input-primary bg-white text-black border border-gray-100 focus:outline-none focus:border-1 w-full mb-2`}
                variant="standard"
                margin="normal"
                required
                fullWidth
                id="otp"
                label="OTP"
                type="number"
                name="otp"
                error={otpError}
                placeholder={"Enter OTP sent to your " + choice}
                onChange={handleChange}
                helperText={otpError ? "OTP is invalid" : ""}
              />
               {otpError && (
              <p className="text-red-500 text-xs mt-1">{otpError}</p>
              )}
              <div className="countdown-text">
                {seconds > 0 || minutes > 0 ? (
                  <p>
                    Time Remaining: {minutes < 10 ? `0${minutes}` : minutes}:
                    {seconds < 10 ? `0${seconds}` : seconds}
                  </p>
                ) : !resentOtp.length ? (
                  <>
                    <div>Didn't recieve code?</div>
                    <Link
                      color="inherit"
                      onClick={resubmitOTP}
                      style={{'color': "blue", "textDecoration": "none"}}
                      // href='http://gsbsoirikapai.com/'
                    >
                      Resend OTP
                    </Link>{" "}
                  </>
                ) : (
                  <p>OTP resent</p>
                )}
              </div>
              <div style={{ fontSize: 14, color: "#DC2626", marginTop:  5 }}>
                *Please remember to check your spam folder for the OTP as well.
              </div>
            </>
          )}
          {/* PASSWORD */}
          {showPassword && (
            <>
              <input
                className={`input input-primary bg-white text-black border border-gray-100 focus:outline-none focus:border-1 w-full mb-2 mt-2`}
                variant="standard"
                margin="normal"
                required
                fullWidth
                name="password"
                label="Password"
                type="password"
                value={password}
                id="password"
                autoComplete="current-password"
                error={passwordError}
                placeholder={"Enter Password"}
                onChange={handleChange}
                helperText={passwordError ? "Password cannot be empty" : ""}
              />
              <input
                className={`input input-primary bg-white text-black border border-gray-100 focus:outline-none focus:border-1 w-full mb-2`}
                variant="standard"
                margin="normal"
                required
                fullWidth
                name="passwordConfirm"
                label="Confirm Password"
                type="password"
                value={passwordConfirm}
                id="passwordConfirm"
                autoComplete="current-password"
                placeholder={"Confirm Password"}
                error={passwordConfirmError}
                onChange={handleChange}
                helperText={
                  passwordConfirmError ? "Password's do not match" : ""
                }
              />
            </>
          )}
          <button
            fullWidth
            className="btn btn-primary text-white font-bold w-full rounded-md my-2"
            variant="contained"
            sx={{ mt: 3, mb: 2 }}
            type="submit"
          >
            Sign Up
          </button>

          <Grid container>
            <Grid item>
              <Link href="login" variant="body2">
                <RouterLink
                  to={"/login"}
                  style={{
                    color: "inherit",
                    border: "inherit",
                  }}
                >
                  {"Already have an account? Sign In"}
                </RouterLink>
              </Link>
            </Grid>
          </Grid>
          <Copyright s={{ mt: 5 }} sx={{mt:2}} />
        </Box>
      </div>
    </div>
  );
}
